import { TextareaBasic } from './TextareaBasic';
import { TextareaControlled } from './TextareaControlled';

export const Textarea = {
  Basic: TextareaBasic,
  Controlled: TextareaControlled,
};
